{
  "version": 1,
  "asset_id": "1ac8b315-2828-4d51-a1dd-5160dd035038",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/1ac8b315-2828-4d51-a1dd-5160dd035038/demo-journey.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/1ac8b315-2828-4d51-a1dd-5160dd035038/demo-journey.webp",
  "original_filename": "demo-journey.webp",
  "size": 70148,
  "content_type": "image/webp",
  "created_at": "2026-10-14T19:14:10Z"
}
